import { createAction } from 'typesafe-actions';

export const addUnitCodes = createAction('ADD_UNIT_CODES')<string[]>();
